import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@mui/styles';
import { Button, Menu, MenuItem, capitalize } from '@mui/material';

import { logout } from 'redux/actions';

const useStyles = makeStyles((theme) => ({
  root: {},
  header: {
    display: 'flex',
    width: '100%',
    minHeight: '60px',
    backgroundColor: '#1f3c3c',
  },
  headerTitle: {
    padding: '0 15px',
    fontSize: '20px',
    lineHeight: '60px',
    fontWeight: '700',
    color: '#fff',
    textDecoration: 'none',
  },
  menuButton: {
    marginLeft: 'auto',
    marginRight: theme.spacing(3),
    color: '#fff',
    textTransform: 'capitalize',
  },
}));

const Layout = ({ children }) => {
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user);
  const [showHeader, setShowHeader] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    if (location?.pathname === '/') {
      setShowHeader(false);
    } else {
      setShowHeader(true);
    }
  }, [location]);

  useEffect(() => {
    setIsLoggedIn(!!user);
  }, [user]);

  const showMenu = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const closeMenu = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    closeMenu();
    dispatch(logout());
  };

  return (
    <div className={classes.root}>
      {showHeader && (
        <header className={classes.header}>
          <a className={classes.headerTitle} href='/'>
            Fluency FlashCards
          </a>
          {isLoggedIn && (
            <Button className={classes.menuButton} onClick={showMenu}>
              {user?.full_name}
            </Button>
          )}
          <Menu
            id='menu-dropdown'
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={closeMenu}
          >
            <MenuItem>Profile</MenuItem>
            <MenuItem onClick={handleLogout}>Sign out</MenuItem>
          </Menu>
        </header>
      )}
      {children}
    </div>
  );
};

export default Layout;
